/** OWN-320: header popovers open down toward the end; the sidebar-footer ones open up toward the start. */
export type PopoverPlacement = "end-down" | "start-down" | "start-up";

const CLASSES: Record<PopoverPlacement, string> = {
  "end-down": "end-0 top-full mt-1",
  "start-down": "start-0 top-full mt-1",
  "start-up": "start-0 bottom-full mb-2",
};

export const popoverPlacementClass = (placement: PopoverPlacement): string => CLASSES[placement];
